import React, { useRef, useState } from "react";
import styles from "./Workspace.module.css";
import SearchIconWithIcon from "../../../SearchIconWithIcon/SearchIconWithIcon";
import FiltersDropdownContainer from "../../../FiltersDropdownContainer/FiltersDropdownContainer";
import KIcon from "../../../../assets/KIcon.svg";
import { ReactComponent as FilterIconBars } from "../../../../assets/S3/filterIconBars.svg";
import { ReactComponent as FacturaLogo } from "../../../../assets/FacturaLogoIconGreen.svg";
import { ReactComponent as DotIcon } from "../../../../assets/DotIcon.svg";

import { useTranslation } from "react-i18next";
import Button from "../../../Button/Button";
import NewWorkspace from "../../../NewWorkspace/NewWorkspace";
const Workspace = ({showWorkspace,setShowWorkspace}) => {
  const [t] = useTranslation("accountSetting");
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters,setShowFilters] = useState(false)
  const searchInputRef = useRef(null);

  const [selectedOption, setSelectedOption] = useState({
    "Orden Alfabético": "A-Z",
    documents: "Mayor a menor",
    contacts: "Mayor a menor",
    assets: "Mayor a menor",
    monthly: "Mayor a menor",
    total: "Mayor a menor",
  });

  const options = [
    {
      name: "Orden Alfabético",
      label: t("alphabeticOrder"),
      subOptions: [
        { display: "A-Z", value: "A-Z" },
        { display: "Z-A", value: "Z-A" },
      ],
    },
    {
      name: "documents",
      label: t("documents"),
      subOptions: [
        { display: t("higherToLower"), value: "Mayor a menor" },
        { display: t("lowerToHigher"), value: "Menor a mayor" },
      ],
    },
    {
      name: "contacts",
      label: t("contacts"),
      subOptions: [
        { display: t("higherToLower"), value: "Mayor a menor" },
        { display: t("lowerToHigher"), value: "Menor a mayor" },
      ],
    },
    {
      name: "assets",
      label: t("assets"),
      subOptions: [
        { display: t("higherToLower"), value: "Mayor a menor" },
        { display: t("lowerToHigher"), value: "Menor a mayor" },
      ],
    },

  ];

  return (
    <div>
      <div>
        <div className={styles.searchFiltersWorkspace}>
          <SearchIconWithIcon
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            ref={searchInputRef}
          >
            <>
              <div
                style={{ marginLeft: "5px" }}
                className={styles.searchIconsWrappers}
              >
                <img src={KIcon} alt="kIcon" />
              </div>
            </>
          </SearchIconWithIcon>

          <div className={styles.filterIconsWrappers} onClick={() => setShowFilters((prev) => !prev)}>
            <FilterIconBars />
          </div>
        </div>
      {showFilters && (
          <FiltersDropdownContainer
          setSelectedFilters={setSelectedOption}
          selectedFilters={selectedOption}
          options={options}
        />
      )}
      </div>

      <div className={styles.labelContainer}>

        <div className={styles.label}>
          <div className={styles.infoWorkspace}>
            <div>
            <FacturaLogo /> <div className={styles.info}>
            <p>Nombre de la cuenta</p>
            <span>info@gmail.com</span>
            </div>
            </div>
          <Button type="white" headerStyle={{ borderRadius: "999px",height:'fit-content' }}>
            {t("manage")}
          </Button>
          </div>
          

            <div className={styles.infoUser}>
                <div className={styles.initials}>a</div>
                <div className={styles.info}>
                <p>Tu <DotIcon/> <span>Rol</span></p>
                <span>info@gmail.com</span>
                </div>
            </div>

        </div>

      </div>
    
    </div>
  );
};

export default Workspace;
